module.exports = __webpack_public_path__ + "static/media/ceilings_material_60yd_y.79c6d0fe.csv";